<template>
  <v-card shaped width="250" height="300" class="elevation-10">
    <v-card-title class="my-0 py-0">
      <v-col justify="start" class="ml-0 pl-0">
        <v-row class="pb-0 ml-0" align="center">
          <v-col cols="8">
            <v-row justify="start">
              <span class="body-2 font-weight-bold">{{ idea.title }}</span>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="caption ml-0 pt-0" align="center" justify="start">
          <span class="px-2">{{ idea.upVote }}</span>
          <v-icon small color="green">mdi-arrow-up</v-icon>
          <v-icon class="px-1" small>mdi-arrow-collapse-horizontal</v-icon>
          <v-icon small color="red">mdi-arrow-down</v-icon>
          <span class="px-2">{{ idea.downVote }}</span>
        </v-row>
      </v-col>
    </v-card-title>
    <v-card-text>
      <span id="desc">{{ idea.description }}</span>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    idea: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      //
    };
  }
};
</script>

<style scoped>
#desc {
  overflow: hidden;
  /* margin-top: -17px; */
  width: 103%;
  display: -webkit-box;
  -webkit-line-clamp: 9;
  -webkit-box-orient: vertical;
}
</style>